var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2763 2.39691C7.93882 1.55323 7.12169 1 6.21301 1H3.15605C1.99334 1 1.05078 1.9426 1.05078 3.10531C1.05078 12.9883 9.06277 21 18.9458 21C20.1085 21 21.0508 20.0575 21.0508 18.8948L21.0507 15.8378C21.0507 14.9292 20.4974 14.1121 19.6537 13.7746L16.7254 12.6032C15.9676 12.3001 15.1047 12.4367 14.4777 12.9593L13.7209 13.5897C12.8379 14.3255 11.5397 14.2667 10.727 13.454L8.59676 11.3239C7.78405 10.5112 7.72549 9.21284 8.46128 8.32989L9.09171 7.57332C9.61425 6.94627 9.75082 6.08327 9.44768 5.32541L8.2763 2.39691Z",
    fill: "#F38D00",
    stroke: "#F5FAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.95a39b923423aa58999173033df0c0b5.svg";
export { ForwardRef as ReactComponent };